import { DeliveryListFilterType, IDeliveryFilter } from '~/client/graph'

export interface IUserNotificationsSettings {
  inApp: boolean
  sms: boolean
  email: boolean
}

export interface IDeliveriesSettings {
  isFollowingFilterActive: boolean
  isMyCompanyFilterActive: boolean
  selectedFilters?: IDeliveryFilter[]
  selectedGroupByOption?: DeliveryListFilterType
}

export interface ISitemapsSetupSettings {
  lastEditedSitemapId?: string
}

export interface ISavedViewSettings {
  workflowCustomFilterId?: string
  uploadLogCustomFilterId?: string
  resourcesCustomFilterId?: string
  notificationCustomFilterId?: string
  isHidden?: boolean
}

export function getDefaultUserNotificationsSettings(): IUserNotificationsSettings {
  return {
    inApp: true,
    sms: true,
    email: true,
  }
}

export function getDefaultWorkflowNotificationsSettings(): IUserNotificationsSettings {
  // Email starts off: users opt in to workflow email.
  return {
    inApp: true,
    sms: true,
    email: false,
  }
}

export function getDefaultDeliveriesSettings(): IDeliveriesSettings {
  return {
    isFollowingFilterActive: false,
    isMyCompanyFilterActive: false,
    selectedFilters: [],
    selectedGroupByOption: DeliveryListFilterType.None,
  }
}
